import { Capacitor } from "@capacitor/core";

export const isCapWeb = () => {
  if (Capacitor.platform === "web") {
    return true;
  } else {
    return false;
  }
};
